
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/banner-builder",
      function () {
        return require("private-next-pages/banner-builder.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/banner-builder"])
      });
    }
  